<section class="page">
  <header class="page-header">
    <h1>Administration</h1>
    <p>Audit trail, roles, and editable permission matrix.</p>
  </header>

  @if (error()) { <div class="error">{{ error() }}</div> }
  @if (loading()) { <div class="loading"><mat-spinner diameter="36"></mat-spinner></div> }

  <mat-tab-group>
    <mat-tab label="Audit">
      <div class="tab-body">
        <table mat-table [dataSource]="auditLogs()" class="full">
          <ng-container matColumnDef="createdAt"><th mat-header-cell *matHeaderCellDef>When</th><td mat-cell *matCellDef="let r">{{ r.createdAt | date:'medium' }}</td></ng-container>
          <ng-container matColumnDef="action"><th mat-header-cell *matHeaderCellDef>Action</th><td mat-cell *matCellDef="let r">{{ r.action }}</td></ng-container>
          <ng-container matColumnDef="entityType"><th mat-header-cell *matHeaderCellDef>Entity</th><td mat-cell *matCellDef="let r">{{ r.entityType || '—' }}</td></ng-container>
          <ng-container matColumnDef="entityId"><th mat-header-cell *matHeaderCellDef>Entity ID</th><td mat-cell *matCellDef="let r">{{ r.entityId || '—' }}</td></ng-container>
          <ng-container matColumnDef="userId"><th mat-header-cell *matHeaderCellDef>User</th><td mat-cell *matCellDef="let r">{{ r.userId || '—' }}</td></ng-container>
          <ng-container matColumnDef="ipAddress"><th mat-header-cell *matHeaderCellDef>IP</th><td mat-cell *matCellDef="let r">{{ r.ipAddress || '—' }}</td></ng-container>
          <tr mat-header-row *matHeaderRowDef="auditColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: auditColumns"></tr>
        </table>
        @if (!auditLogs().length && !loading()) { <p class="muted">No audit logs found.</p> }
      </div>
    </mat-tab>

    <mat-tab label="Roles">
      <div class="tab-body">
        <div class="create-role">
          <mat-form-field appearance="outline">
            <mat-label>New role name</mat-label>
            <input matInput [(ngModel)]="newRoleName" maxlength="100" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="grow">
            <mat-label>Description</mat-label>
            <input matInput [(ngModel)]="newRoleDescription" maxlength="500" />
          </mat-form-field>
          <button mat-flat-button color="primary" type="button" [disabled]="creatingRole()" (click)="createRole()">
            {{ creatingRole() ? 'Creating…' : 'Add role' }}
          </button>
        </div>

        <table mat-table [dataSource]="roles()" class="full">
          <ng-container matColumnDef="name"><th mat-header-cell *matHeaderCellDef>Role</th><td mat-cell *matCellDef="let r">{{ r.name }}</td></ng-container>
          <ng-container matColumnDef="code"><th mat-header-cell *matHeaderCellDef>Code</th><td mat-cell *matCellDef="let r"><code>{{ r.code || '—' }}</code></td></ng-container>
          <ng-container matColumnDef="description"><th mat-header-cell *matHeaderCellDef>Description</th><td mat-cell *matCellDef="let r">{{ r.description || '—' }}</td></ng-container>
          <ng-container matColumnDef="isSystem"><th mat-header-cell *matHeaderCellDef>System</th><td mat-cell *matCellDef="let r">{{ r.isSystem ? 'Yes' : 'No' }}</td></ng-container>
          <ng-container matColumnDef="permissionCount"><th mat-header-cell *matHeaderCellDef>Permissions</th><td mat-cell *matCellDef="let r">{{ permissionCount(r) }}</td></ng-container>
          <tr mat-header-row *matHeaderRowDef="roleColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: roleColumns"></tr>
        </table>
      </div>
    </mat-tab>

    <mat-tab label="Permissions">
      <div class="tab-body">
        <p class="hint">Toggle checkboxes to grant or revoke permissions for each role. Changes save immediately.</p>
        <div class="matrix-wrap">
          <table class="matrix">
            <thead>
              <tr>
                <th>Permission</th>
                @for (role of roles(); track role.id) {
                  <th>{{ role.name }}</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (module of modules(); track module) {
                <tr class="module-row"><td [attr.colspan]="roles().length + 1"><strong>{{ module }}</strong></td></tr>
                @for (perm of permissionsForModule(module); track perm.id) {
                  <tr>
                    <td>
                      <div>{{ perm.name }}</div>
                      <code>{{ perm.code }}</code>
                    </td>
                    @for (role of roles(); track role.id) {
                      <td class="check-cell">
                        <mat-checkbox
                          [checked]="!!matrixRow(perm.id)?.roleChecks?.[role.id]"
                          [disabled]="savingRoleId() === role.id"
                          (change)="togglePermission(role, perm, $event.checked)"
                          [matTooltip]="role.name + ' · ' + perm.code">
                        </mat-checkbox>
                      </td>
                    }
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</section>
